import React, { useState, useEffect } from 'react'
import { withUserStore } from '../../../contexts/UserStore'

const GoalsPanel = ({ userStore }) => {
  const [userGoals, setUserGoals] = useState([])

  useEffect(() => {
    if (userStore.account && userStore.currentAccountsUser) {
      // Get goals owned by the current user
      const goals = userStore.account.goals?.filter(
        goal => goal.accountsUserId === userStore.currentAccountsUser.id
      ) || []

      // Enrich each goal with its strategy and priority information
      const enrichedGoals = goals.map(goal => {
        const strategy = userStore.account.strategies?.find(s => s.id === goal.strategyId)
        const priority = strategy ? userStore.account.priorities?.find(p => p.id === strategy.priorityId) : null

        return {
          ...goal,
          strategy,
          priority
        }
      })

      setUserGoals(enrichedGoals)
    }
  }, [userStore.account, userStore.currentAccountsUser])

  return userGoals.length === 0 ? (
    <div className="text-center p-4 text-muted">
      <i className="fas fa-bullseye fa-2x mb-2 d-block"></i>
      No goals yet
    </div>
  ) : (
    <div className="d-flex flex-column gap-2">
      {userGoals.map(goal => (
        <div
          key={goal.id}
          className="border border-gray-300 rounded-md p-3"
          style={{ backgroundColor: '#f8f9fa' }}
        >
          {goal.priority && (
            <div className="mb-1">
              <i className="fas fa-flag me-1 text-primary"></i>
              {goal.priority.name}
            </div>
          )}
          {goal.strategy && (
            <div className="mb-2">
              <i className="fas fa-chess me-1 text-primary"></i>
              {goal.strategy.name}
            </div>
          )}
          <div className="fw-semibold">
            <i className="fas fa-bullseye me-1 text-primary"></i>
            {goal.name}
          </div>
          {goal.description && (
            <div className="text-muted small mt-1">
              {goal.description}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default withUserStore(GoalsPanel)
